<template>
	<div
		class="SortPanelItemLoading"
		v-skeleton="{
			loading: true,
			sizes: {
				Small: { width: '100%', height: '1.5rem' },
				Large: { width: '100%', height: '1.5rem' },
				ExtraLarge: { width: '100%', height: '1.5rem' },
			},
			margins: {
				Small: '0 0 1.5rem 0',
				Large: '0 0 1rem 0',
				ExtraLarge: '0 0 1rem 0',
			}
		}"
		aria-hidden="true"
	></div>
</template>
